import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaDocumentosProduzidos } from './types';

export const INITIAL_STATE: ConsultaDocumentosProduzidos = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaDocumentosProduzidos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_DOCUMENTOS_PRODUZIDOS_REQUEST: {
				break;
			}
			case Types.CONSULTA_DOCUMENTOS_PRODUZIDOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_DOCUMENTOS_PRODUZIDOS_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_DOCUMENTOS_PRODUZIDOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
